import React from "react";
import styled from "styled-components";
import Link from "gatsby-link";
import Logo from "./Logo";
import { getThemeColor } from "../utils";
import Spacer from "./blocks/Spacer";
import Flex from "./blocks/Flex";
import linkedinIcon from "../../assets/linkedin-icon.svg";
import instagramIcon from "../../assets/instagram-icon.svg";

const SHOW_NEST_NAV = true;

const OuterDiv = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: stretch;
  transition: opacity 300ms;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  bottom: ${props => (props.isVisible ? 0 : "100%")};
  margin: 0;
  padding: 0;
  background-color: ${getThemeColor("purpleDark")};
`;

const InnerDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2.1rem 5rem;
  max-width: 72rem;
  width: 100%;
  height: 100vh;
  min-height: max-content;
  ${props => props.theme.media.mobile`
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-right: 0;
  `};
`;

const Links = styled.div`
  font-size: 2rem;
  padding-top: .125rem;
  ${props => props.theme.media.mobile`
  width: 80%;
  `};
`;

const NavigationLink = styled(Link)`
  font-size: ${({ small }) => (small ? "1.1rem" : "2.0rem")};
  display: flex;
  justify-content: flex-end;
  padding-bottom: 1rem;
  color: ${getThemeColor("white")};
  text-decoration: none;
`;

const NavLink = props =>
  <Flex justify="flex-end">
    <NavigationLink {...props} />
  </Flex>;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const DropdownLabel = styled.div`
  font-size: 2.0rem;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 1rem;
  color: ${getThemeColor("white")};
  text-decoration: none;
`;

const DropdownItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
`;

const DropdownLink = styled(Link)`
  font-size: 1.4rem;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 0.5rem;
  color: ${getThemeColor("white")};
  text-decoration: none;
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }
`;

const LogoSection = styled(NavigationLink)`
  padding-right: 2.3125rem;
  padding-bottom: 2rem;
  ${props => props.theme.media.mobile`
    padding: 0;
    padding-bottom: calc(3rem + 8px);
    width: 80%;
  `};
`;

const Social = () =>
  <Flex justify="flex-end" style={{ width: "100%" }}>
    <Flex justify="space-between" style={{ width: 100 }}>
      <a href="https://www.linkedin.com/company/contraline" target="_blank" rel="noopener noreferrer">
        <img src={linkedinIcon} style={{ height: 32 }} alt="LinkedIn" />
      </a>
      <a href="https://www.instagram.com/contraline/" target="_blank" rel="noopener noreferrer">
        <img src={instagramIcon} style={{ height: 32 }} alt="Instagram" />
      </a>
    </Flex>
  </Flex>;

const SubLink = styled(Link)`
  font-size: 1.3rem;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 0.6rem;
  color: ${getThemeColor("white")};
  text-decoration: none;

  &:hover {
    opacity: 0.7;
  }
`;

const NavMenu = ({ isVisible, toggleMenuVisibility }) =>
  <OuterDiv isVisible={isVisible}>
    <InnerDiv onClick={toggleMenuVisibility}>
      <LogoSection to="/">
        <Logo color="white" />
      </LogoSection>
      <Links>
        <NavLink to="/trials">Pipeline</NavLink>
        <SubLink to="/nestorone" style={{ paddingBottom: "calc(0.6rem + 4px)" }}>NES/T</SubLink>
        <SubLink to="/product">ADAM</SubLink>
        <NavLink to="/mission">Mission</NavLink>
        <NavLink to="/team">Team</NavLink>
        <NavLink to="/news">News</NavLink>
        <NavLink to="/careers">Careers</NavLink>
        <NavLink to="/participate">Participate</NavLink>
        <Spacer span={1} />
        <Social />
      </Links>
    </InnerDiv>
  </OuterDiv>;

export default NavMenu;



// WEBPACK FOOTER //
// ./src/components/NavMenu.js